module.exports = __webpack_public_path__ + "static/media/timelify-bold.3579c701.otf";